import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {
  EvenementSpontane,
  IEvenementSpontane,
} from '../../_models/EvenementSpontane';
import {
  Action,
  createAction,
  createReducer,
  props,
  on,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';

export const name = 'evenementSpontanes';

export interface EvenementSpontaneState
  extends EntityState<IEvenementSpontane> {
  selectedId: number | null;
  isInitialized: boolean;
  loading: boolean;
}

function selectEvenementSpontane(a: IEvenementSpontane): any {
  return a.id;
}

function sortById(a: IEvenementSpontane, b: IEvenementSpontane): number {
  if (a.id < b.id) {
    return -1;
  } else if (a.id > b.id) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<IEvenementSpontane> =
  createEntityAdapter<IEvenementSpontane>({
    selectId: selectEvenementSpontane,
    sortComparer: sortById,
  });

const initialState: EvenementSpontaneState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  loading: true,
});

/* ACTION */
export const loadEvenementSpontanesAction = createAction(
  '[EvenementSpontane] Load EvenementSpontanes'
);
export const loadEvenementSpontanesErrorAction = createAction(
  '[EvenementSpontane] Load EvenementSpontanes Error'
);
export const loadEvenementSpontanesSuccessAction = createAction(
  '[EvenementSpontane] Load EvenementSpontanes Success',
  props<{ payload: IEvenementSpontane[] }>()
);
export const setEvenementsSpontanesAction = createAction(
  '[EvenementSpontane] Add EvenementSpontane',
  props<{ payload: IEvenementSpontane[] }>()
);

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadEvenementSpontanesSuccessAction, (state, {payload}) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  }),
  on(loadEvenementSpontanesErrorAction, (state) => {
    return {...state, loading: false};
  }),
  on(setEvenementsSpontanesAction, (state, {payload}) => {
    return adapter.setAll(payload, state);
  }),
);

export function evenementSpontaneReducer(
  state: EvenementSpontaneState | undefined,
  action: Action
): EvenementSpontaneState {
  return reducer(state, action);
}

/* SELECTOR */
const selectEvenementSpontaneState =
  createFeatureSelector<EvenementSpontaneState>(name);

const isInitialized = (state: EvenementSpontaneState) => state.isInitialized;
export const {selectIds, selectEntities, selectAll, selectTotal} =
  adapter.getSelectors();

export const selectAllEvenementSpontanes = createSelector(
  selectEvenementSpontaneState,
  (state) => {
    return state.loading
      ? undefined
      : state.ids.map((id: any) => new EvenementSpontane(state.entities[id]));
  }
);
export const selectIsEvenementSpontaneInitialized = createSelector(
  selectEvenementSpontaneState,
  isInitialized
);
